import { render, staticRenderFns } from "./plattask-add-or-update.vue?vue&type=template&id=e4803202&"
import script from "./plattask-add-or-update.vue?vue&type=script&lang=js&"
export * from "./plattask-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports